// extracted by mini-css-extract-plugin
module.exports = {"cf-image":"OfferImage_cf-image__TxNr5","cf-image-contain":"OfferImage_cf-image-contain__JXU9c"};